import { gql } from '@apollo/client';

export const SET_SITE_MAIN_IMAGE_MUTATION = gql`
  mutation SetSiteMainImageMutation($siteId: String!, $imageId: String!) {
    setSiteMainImage(siteId: $siteId, imageId: $imageId) {
      ... on UpdateSiteSuccess {
        site {
          id
          image
          imageCropPosition {
            x
            y
          }
          images
          updatedAt
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
